export default __webpack_public_path__ + "static/media/adminv1.086cf961.svg";